import React, { useState, useEffect, useRef } from 'react';
import { KTSVG } from '../../../../../_mexablock/helpers';
import { useFormik } from 'formik';
import Select from 'react-select';
import { useSelectUser } from '../../cancelaciones/hooks/CancelacionesHook';
import { FilterMov } from './FilterDate';
type Props = {
  initFilterValues: any;
  onCleanFilter: () => void;
  onSearchFilter: (values: any) => void;
  showFilterCode: boolean;
  noAuto?: boolean;
};

const Filter: React.FC<Props> = ({
  initFilterValues,
  onSearchFilter,
  onCleanFilter,
  showFilterCode,
  noAuto = true,
}) => {
  const [filterValues, setFilterValues] = useState(initFilterValues);
  const dateInputRef = useRef<HTMLInputElement | null>(null);
  const [rolType, setrolType] = useState<number>(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const { data: usersSelect } = useSelectUser(
    true,
    showFilterCode,
    rolType,
    noAuto
  );
  const [cleanDate, setCleanDate] = useState<boolean>(false);
  const [initFilter, setInitFilter] = useState({
    init_date: '',
    end_date: '',
  });

  useEffect(() => {
    if (initFilterValues) {
      setFilterValues(initFilterValues);
    }
  }, [initFilterValues]);

  const formFilter = useFormik({
    initialValues: filterValues,
    enableReinitialize: true,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      onSearchFilter({ ...values, filter: 1 });
    },
  });

  const handleCodes = (selectedOption: any) => {
    const id = selectedOption.value;
    setSelectedOption(selectedOption);
    formFilter.setFieldValue('user_id', id);
  };

  const handleTipe = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const id = Number(e.target.value);
    setSelectedOption(null);
    formFilter.setFieldValue('user_id', 0);
    setrolType(id);
    formFilter.setFieldValue('rol_id', id);
  };

  return (
    <>
      <div className="card-title align-items-start flex-column">
        <a
          href="#/"
          className={
            formFilter.values.filter !== 0
              ? ' btn btn-sm btn-primary'
              : 'btn btn-sm btn-light-primary'
          }
          data-kt-menu-trigger="click"
          data-kt-menu-placement="right-start"
        >
          <KTSVG
            path="/media/icons/duotune/general/gen031.svg"
            className="svg-icon-5 svg-icon-gray-500 me-1"
          />
          Filtrar
        </a>
        <div
          className="menu menu-sub menu-sub-dropdown w-250px w-md-300px ms-2"
          data-kt-menu="true"
        >
          <div className="px-7 py-5">
            <div className="fs-5 text-dark fw-bolder">Opciones de filtro</div>
          </div>

          <div className="separator border-gray-200"></div>
          <form
            id="kt_modal_generic_form"
            className="form"
            action="#"
            onSubmit={formFilter.handleSubmit}
          >
            <div className="px-7 py-5">
              {/* <div className="mb-5">
                <label className="form-label fw-bold">Fecha inicial:</label>
                <input
                  type="date"
                  className="form-control"
                  ref={dateInputRef}
                  onKeyDown={(e) => e.preventDefault()}
                  value={formFilter.values.init_date || ''}
                  onInput={(e) => {
                    const target = e.target as HTMLInputElement;
                    if (target.value === '') {
                      formFilter.setFieldValue('init_date', '');
                    }
                  }}
                  onChange={(e) => {
                    if (e.target.value) {
                      const fecha = new Date(e.target.value)
                        .toISOString()
                        .split('T')[0];
                      formFilter.setFieldValue('init_date', fecha);
                    }
                  }}
                ></input>
              </div>
              <div className="mb-5">
                <label className="form-label fw-bold">Fecha fin:</label>
                <input
                  type="date"
                  className="form-control"
                  onKeyDown={(e) => e.preventDefault()}
                  value={formFilter.values.end_date || ''}
                  onInput={(e) => {
                    const target = e.target as HTMLInputElement;
                    if (target.value === '') {
                      formFilter.setFieldValue('end_date', '');
                    }
                  }}
                  onChange={(e) => {
                    if (e.target.value) {
                      const fecha = new Date(e.target.value)
                        .toISOString()
                        .split('T')[0];
                      formFilter.setFieldValue('end_date', fecha);
                    }
                  }}
                ></input>
              </div> */}
              <div className="mb-5 w-100">
                <FilterMov
                  valueInit={formFilter.values.init_date}
                  valueEnd={formFilter.values.end_date}
                  setInitDate={(v) => formFilter.setFieldValue('init_date', v)}
                  setEndDate={(v) => formFilter.setFieldValue('end_date', v)}
                  onCleanFilter={() => {
                    formFilter.setFieldValue('init_date', '');
                    formFilter.setFieldValue('end_date', '');
                  }}
                  changeName={cleanDate}
                />
              </div>
              <div className="mb-5">
                <label className="form-label fw-bold">Tipo:</label>
                <select
                  className="form-select"
                  {...formFilter.getFieldProps('rol_id')}
                  onChange={handleTipe}
                >
                  <option value={0}>Seleccione un tipo</option>
                  <option value={2}>Administrador</option>
                  <option value={13}>Call center</option>
                </select>
              </div>

              <div className="mb-5">
                <label className="form-label fw-bold">Usuario:</label>
                <div onClick={(e) => e.stopPropagation()}>
                  <Select
                    options={usersSelect}
                    placeholder={'Seleccione'}
                    onChange={handleCodes}
                    value={selectedOption}
                    noOptionsMessage={() => {
                      return <span>No hay registros</span>;
                    }}
                    styles={{
                      placeholder: (provided, state) => ({
                        ...provided,
                        color: '#181c32',
                      }),
                      indicatorSeparator: (provided, state) => ({
                        ...provided,
                        display: 'none',
                      }),
                      dropdownIndicator: (provided, state) => ({
                        ...provided,
                        color: '#7E8199',
                      }),
                      control: (provided, state) => ({
                        ...provided,
                        border: '1px solid #e4e6ef',
                        borderRadius: '6px',
                        padding: '3px',
                        fontSize: '1.1rem',
                        boxShadow: 'none',
                        backgroundColor: state.isDisabled ? '#EFF2F5' : 'white',
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        fontSize: '1.1rem',
                      }),
                    }}
                  />
                </div>
              </div>

              <div className="d-flex justify-content-end">
                <button
                  type="reset"
                  className="btn btn-sm btn-white btn-active-light-primary me-2"
                  data-kt-menu-dismiss="true"
                  onClick={() => {
                    formFilter.resetForm();
                    setSelectedOption(null);
                    onCleanFilter();
                    setrolType(0);
                    setCleanDate(true);
                    setTimeout(() => setCleanDate(false), 0);
                  }}
                >
                  Limpiar
                </button>

                <button
                  type="submit"
                  className="btn btn-sm btn-primary"
                  data-kt-menu-dismiss="true"
                >
                  Buscar
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export { Filter };
